export const environment = {
  production: true,
  apiUrl: 'https://nvti-atalho-api.azurewebsites.net',
  saldoKey: 'saldo',
  tokenKey: 'auth_token',
  saldoTimestampKey: 'saldo_timestamp',
  nomeUsuarioKey: 'nome_usuario',
  nomeClienteKey: 'nome_cliente',
  ipUsuarioKey: 'ip_usuario',
  tempoExpiracaoCacheSaldoMinutos: 10,
  tempoMinimoRenovacaoTokenMinutos: 10,
  tempoAlertaExpiracaoTokenMinutos: 3,
  tempoConfirmarRenovarSessaoSegundos: 30,
  filtroSegmentacaoKey: 'filtro_segmentacao',
  todasPermissoesKey: 'todas_permissoes',
  todasPermissoesTempoExpiracaoKey: 'todas_permissoes_timestamp',
  tempoExpiracaoCachePermissoesMinutos: 10,  
  urlBaseRecarga: 'https://controlecreditos.novavidati.com.br/',
  primeiroAcessoKey: 'primeiroAcesso',
  idProduto: 45,
  urlSignalrNegotiate: 'https://nvti-processador-pagamentos.azurewebsites.net/api/negotiate',
  urlSendMessage: 'https://nvti-processador-pagamentos.azurewebsites.net/api/sendmessage',
  tipoClienteKey: 'tipo_cliente',
};
